import { Button, PageHeader, Descriptions, Card, Table, Spin } from 'antd'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'

import Error from '../../components/Error'
import { getProductStockById } from '../../network/ProductStock'
import { createUrlWithFiltersFromCurrentURL } from '../../utils/filterUtils'

const ViewProductStock = ({ history }) => {
  const { id } = useParams()

  const { data, isError, isLoading, refetch } = useQuery(
    ['getProductStockById', { id }],
    getProductStockById,
    { refetchOnWindowFocus: false, enabled: !!id }
  )

  if (isError) {
    return (
      <>
        <PageHeader
          className="site-page-header"
          title="View product stock"
          onBack={() => history.push(createUrlWithFiltersFromCurrentURL('/fixed-sku-stock'))}
        />
        <Error retry={refetch} />
      </>
    )
  }

  if (isLoading || !data) {
    return (
      <>
        <PageHeader
          className="site-page-header"
          title="View product stock"
          onBack={() => history.push(createUrlWithFiltersFromCurrentURL('/fixed-sku-stock'))}
        />
        <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
          <Spin size="large" />
        </div>
      </>
    )
  }

  const fixedSku = data.fixedSku || {}
  const store = data.store || {}
  const stock = Array.isArray(data.stock) ? data.stock : []
  const storeName =
    typeof store.name === 'string' ? store.name : (store.name?.en || store.name?.zh || '–')

  const stockColumns = [
    { title: 'Size (EN)', dataIndex: 'size_name_en', key: 'size_name_en', render: (v) => v || '–' },
    { title: 'Size (中文)', dataIndex: 'size_name_zh', key: 'size_name_zh', render: (v) => v || '–' },
    { title: 'Stock', dataIndex: 'stock', key: 'stock', render: (v) => v ?? '–' },
  ]

  return (
    <>
      <PageHeader
        className="site-page-header"
        title="View product stock"
        onBack={() => history.push(createUrlWithFiltersFromCurrentURL('/fixed-sku-stock'))}
        style={{ backgroundColor: '#fff' }}
        extra={[
          <Button
            key="history"
            onClick={() => history.push(createUrlWithFiltersFromCurrentURL(`/fixed-sku-stock/history/${id}`))}
          >
            History
          </Button>,
          <Button
            key="manage"
            type="primary"
            onClick={() => history.push(createUrlWithFiltersFromCurrentURL(`/fixed-sku-stock/manage/${id}`))}
          >
            Manage stock
          </Button>,
        ]}
      />
      <div style={{ padding: 24, backgroundColor: '#f0f2f5', minHeight: 'calc(100vh - 64px)' }}>
        <div style={{ margin: '0 auto' }}>
          <Card title="Details" style={{ marginBottom: 24 }}>
            <Descriptions bordered column={1} size="small">
              <Descriptions.Item label="Fix SKU">{fixedSku.sku ?? '–'}</Descriptions.Item>
              <Descriptions.Item label="Fix SKU name">
                {fixedSku.name?.en ?? fixedSku.name?.zh ?? '–'}
              </Descriptions.Item>
              <Descriptions.Item label="Store">{storeName}</Descriptions.Item>
            </Descriptions>
          </Card>
          <Card title="Stock by size">
            {stock.length === 0 ? (
              <div style={{ color: '#999' }}>No stock entries</div>
            ) : (
              <Table
                dataSource={stock.map((row, idx) => ({ ...row, key: idx }))}
                columns={stockColumns}
                pagination={false}
                size="small"
              />
            )}
          </Card>
        </div>
      </div>
    </>
  )
}

export default ViewProductStock
